// The single writer of the home page search URL (reader: searchParams.ts).
// Used by TopSection (search bar, filters, type toggle) and SearchPagination
// so every link and push produces the same shape.
//
// Semantics preserved from the original inline serializer: falsy values are
// dropped; v / ip default to true when null (the "no format filter" state).

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { SEARCH_TYPE_GROUPS, type SearchType } from "./searchParams"

export type SearchHrefInput = {
  searchTerm?: string | null
  location?: string | null
  groupTypes?: readonly string[] | null
  providerTypes?: readonly string[] | null
  virtual?: boolean | null
  inPerson?: boolean | null
  latitude?: number | null
  longitude?: number | null
  type?: SearchType | null
  page?: number | null
}

export function buildSearchHref(input: SearchHrefInput = {}): string {
  const {
    searchTerm,
    location,
    groupTypes,
    providerTypes,
    virtual = null,
    inPerson = null,
    latitude,
    longitude,
    type,
    page,
  } = input

  const params: Array<[string, unknown]> = [
    ["type", type && type !== SEARCH_TYPE_GROUPS ? type : null],
    ["search", searchTerm],
    ["loc", location],
    ["gt", groupTypes?.length ? JSON.stringify(groupTypes) : null],
    ["pt", providerTypes?.length ? JSON.stringify(providerTypes) : null],
    ["v", virtual !== null ? virtual : true],
    ["ip", inPerson !== null ? inPerson : true],
    ["latitude", latitude],
    ["longitude", longitude],
    ["page", page && page > 1 ? page : null],
  ]

  const query = params
    .filter(([, value]) => value)
    .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
    .join("&")

  return query ? `/?${query}` : "/"
}
